import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CompanyModulesPicker } from "@/components/CompanyModulesPicker";
import { api } from "@/lib/api";
import { modulesSummary } from "@/lib/modules";

// Owner: pick which features a company uses (they can also change it in their Settings).
export const ModulesDialog = ({ company, onClose, onSaved }) => {
  const [mods, setMods] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (company) setMods(company.modules || []); }, [company]);
  const save = async () => {
    setBusy(true);
    try { const r = await api.ownerSetModules(company.id, mods); onSaved(company.id, r.modules); toast.success(`${company.name}: ${modulesSummary(r.modules)}`); onClose(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not save features"); }
    finally { setBusy(false); }
  };
  return (
    <Dialog open={!!company} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="owner-modules-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Features · {company?.name}</DialogTitle>
          <DialogDescription>What this company sees. They can change it themselves in Settings.</DialogDescription>
        </DialogHeader>
        <CompanyModulesPicker value={mods} onChange={setMods} disabled={busy} />
        <DialogFooter>
          <Button onClick={save} disabled={busy} className="rounded-full bg-primary hover:bg-primary/90 text-white" data-testid="owner-modules-save">
            {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Save features
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
